"use client";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import UserContext from "@/context/userContext";
import SelectedExperContext from "@/context/selectedExperContext";
import SurveyDataContext from "@/context/surveyDataContext";
import SurveyContext from "@/context/surveyContext";
import CustomExperContext from "@/context/customExperContext";
import SurveyReminderContext from "@/context/surveyReminderContext";
import ParseContext from "@/context/parseContext";
import VideoIntroContext from "@/context/videoIntroContext";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Badge from "@mui/material/Badge";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationIcon from "@mui/icons-material/Notifications";
import AccountCircle from "@mui/icons-material/AccountCircle";
import HomeIcon from "@mui/icons-material/Home";
import Typography from "@mui/material/Typography";
import Image from "next/image";
import { Stack } from "@mui/material";
import { useRouter } from "next/navigation";
import { usePendingPostSurveyCount } from "@/hooks/usePendingPostSurveyCount";
import { useTheme } from "@mui/material/styles";

/**
 * A React component to display the top navigation frame for the YEX web application.
 *
 * @remarks
 * This component uses the React Context API to keep track of the YEX user.  If the
 * YEX user had logged in, an Icon with the user ID is displayed on the right side of
 * the navigation bar.
 *
 * @param props - React component props not currently used.
 * @returns - The TopNav React component in JSX.
 */
export default function TopNav(props: any) {
  const { user } = useContext(UserContext);
  const { setSelectedExper } = useContext(SelectedExperContext);
  const { setSurveyData } = useContext(SurveyDataContext);
  const { setSurvey } = useContext(SurveyContext);
  const { customExper, setCustomExper } = useContext(CustomExperContext);
  const { setSurveyReminder } = useContext(SurveyReminderContext);
  const router = useRouter();
  const Parse = useContext(ParseContext);
  const { setVideoIntro } = useContext(VideoIntroContext);
  const [pendingPostSurveys, setPendingPostSurveys] = useState(0);
  const theme = useTheme();
  console.log("Parse in TopNav", Parse);

  const {
    fetchedOutstandingPostSurveyCountData,
    fetchedOutstandingPostSurveyCountIsLoading,
    fetchedOutstandingPostSurveyCountIsError,
    fetchedOutstandingPostSurveyCountError,
  } = usePendingPostSurveyCount(user);

  useEffect(() => {
    async function setSurveys() {
      if (user) {
        console.log(
          "pendingPostSurveys",
          fetchedOutstandingPostSurveyCountData
        );
        setPendingPostSurveys(
          Math.round(fetchedOutstandingPostSurveyCountData / 2)
        );
      }
      if (user && Math.round(fetchedOutstandingPostSurveyCountData / 2) == 0) {
        console.log("TopNav: setting survey reminder to false");
        setSurveyReminder(false);
      }
    }
    console.log("in TopNav useEffect");
    setSurveys();
  }, [fetchedOutstandingPostSurveyCountData, setSurveyReminder, user]);

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: theme.palette.secondary.dark }}
      elevation={0}
    >
      <Toolbar
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        {/* Top Row: IconButtons in the upper-right corner */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          {user && (
            <Stack direction="row" spacing={2}>
              <IconButton
                size="large"
                edge="start"
                color="primary"
                aria-label="menu"
                onClick={() => {
                  router.push("/");
                  setSurveyData(null);
                  setSurvey("");
                  setSelectedExper(null);
                  setCustomExper(false);
                  setVideoIntro(false);
                }}
              >
                <HomeIcon />
              </IconButton>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: theme.palette.secondary.light,
                }}
              >
                <IconButton size="large" color="primary">
                  <AccountCircle />
                </IconButton>
                {user.get("username")}
              </Typography>
              <IconButton
                size="large"
                edge="end"
                color="primary"
                aria-label="menu"
                onClick={() => {
                  router.push("/postsurvey");
                }}
              >
                <Badge badgeContent={pendingPostSurveys} color="secondary">
                  <NotificationIcon />
                </Badge>
              </IconButton>
            </Stack>
          )}
        </Box>

        {/* Second Row: Centered Image */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            marginTop: 2,
            marginBottom: 15,
          }}
        >
          <Image src="/yex-logo.png" alt="YEX Logo" width={300} height={200} />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
